import "./style.css";

export const ComplianceSection = ({ onContactClick }) => {
  return (
    <section className="compliance-section">
      <div className="compliance-container">
        <div className="compliance-card">
          <h2 className="compliance-title">How It Works</h2>
          <h3 className="compliance-subtitle">
            Your Compliance is Our Priority<br />
            Never Miss a Deadline
          </h3>
          
          <div className="compliance-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Dedicated CA assigned within few hours</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Timely compliances reminders.</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>24/7 access to your business solutions.</span>
            </div>
          </div>
          
          <button className="compliance-btn" onClick={onContactClick}>Explore All Compliances →</button>
          
          <div className="compliance-illustration">
            <div className="chart-bars">
              <div className="bar" style={{height: '40%'}}></div>
              <div className="bar" style={{height: '60%'}}></div>
              <div className="bar" style={{height: '80%'}}></div>
              <div className="bar" style={{height: '100%'}}></div>
            </div>
          </div>
        </div>
        
        <div className="highlights-card">
          <h2 className="highlights-title">Trusted Service Highlights</h2>
          <h3 className="highlights-subtitle">
            Unlock Business Growth<br />
            Focus on What Matters
          </h3>
          
          <div className="highlights-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Save time on physical meetups</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Get Solutions over a call</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span>Dedicated support team</span>
            </div>
          </div>
          
          <button className="highlights-btn" onClick={onContactClick}>Explore Various Services →</button>
          
          <div className="calendar-illustration">
            <div className="calendar-icon">
              <div className="calendar-header"></div>
              <div className="calendar-grid">
                <div className="calendar-cell"></div>
                <div className="calendar-cell"></div>
                <div className="calendar-cell"></div>
                <div className="calendar-cell"></div>
                <div className="calendar-cell"></div>
                <div className="calendar-cell"></div>
              </div>
              <div className="calendar-checkmark">✓</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


